import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Ortak } from './../../../providers/ortak';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';

/**
 * Generated class for the PersonelPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-personel',
  templateUrl: 'personel.html',
})
export class PersonelPage {
  cari: any = { ID: -1, Definition_: "",GrupRef:3 };
  vwCari: any = {};

  aranan = "";
  skip: number = 0;
  take: number = 50;

  constructor(public navCtrl: NavController,
     public bllOrtak:BllOrtak,
     public ortak:Ortak,
     public viewCtrl:ViewController,
     public navParams: NavParams) {
    if (navParams.get("vwCari") != null) {
      this.vwCari = navParams.get("vwCari");
      var data = new FormData();
      data.append("cari_id", this.vwCari.ID);
      this.bllOrtak.islem(data, "CariGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.cari = Sonuc.SonucObject;
      }
      )
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PersonelPage');
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  boslukKontrol() {
    var mesaj = "";
    if (this.cari.Definition_ == null || this.cari.Definition_ == "") {
      mesaj = mesaj + "Lütfen cari adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
  
    if (this.boslukKontrol()) {
      formData.append("cari_json", JSON.stringify(this.cari));
      console.log("gidencari",this.cari);
      this.bllOrtak.islem(formData, "CariEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        // this.cari = sonuc.SonucObject;
       

      })
    }


  }


}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/personel/personel.ts